module.exports = __webpack_public_path__ + "img/7.b94d5be4.jpg";